import { render, staticRenderFns } from "./PlaceMediaAdd.vue?vue&type=template&id=33949d6c&scoped=true&"
import script from "./PlaceMediaAdd.vue?vue&type=script&lang=js&"
export * from "./PlaceMediaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33949d6c",
  null
  
)

export default component.exports